import { useEffect } from "react";

import { Alert } from "@/atoms";
import type { ToastInterface } from "@/interfaces";

export const Toast = ({
    onDismiss,
    toast,
}: {
    onDismiss: (id: string) => void,
    toast: ToastInterface,
}) => {
    const {
        durationMs,
        id,
        message,
        variant,
    } = toast;

    const defaultDurationMs = 4000;

    useEffect(
        () => {
            const duration = durationMs ?? defaultDurationMs;

            if (duration <= 0) return;

            const timer = window.setTimeout(
                () => onDismiss(id),
                duration,
            );

            return () => window.clearTimeout(timer);
        },
        [toast, onDismiss],
    );

    return (
        <div
            className="
                pointer-events-auto
                w-full
                max-w-sm
                shadow-lg
            "
        >
            <Alert
                variant={variant}
                onClose={() => onDismiss(id)}
            >
{message}
</Alert>
        </div>
    );
};
